import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import styles from "./EditConfirmationPage.module.css";
import axios from "axios";
import setAuthToken from "../../functions/auth_header";
import { getAppUrl } from "../../functions/getEnv";
import { toast } from "react-toastify";

const EditConfirmationPage = () => {
  const { charter_id, name, permalink,courseid, id } = useParams();

  const appUrl = getAppUrl(import.meta.env.VITE_NODE_ENV);
  const [content, setContent] = useState("");
  const [hasExistingTemplate, setHasExistingTemplate] = useState(false);

  const stripHtmlTags = (html) => {
    const doc = new DOMParser().parseFromString(html, "text/html");
    return doc.body.textContent || "";
  };

  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      ["bold", "italic", "underline", "strike"],
      [{ list: "ordered" }, { list: "bullet" }],
      [{ color: [] }, { background: [] }],
      [{ font: [] }],
      [{ align: [] }],
      ["link", "image"],
      ["clean"],
    ],
  };

  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "list",
    "bullet",
    "color",
    "background",
    "font",
    "align",
    "link",
    "image",
  ];

  const defaultPlaceholder = `You are considered registered and there is nothing more you need to do unless you are contacted by the school for additional information.
    \n One of our staff members will contact you with instructions and information on how to start your course. They will also be able to answer any questions you may have.
    \n We look forward to working with you!`;

  useEffect(() => {
    const fetchTemplate = async () => {
      try {
        if (localStorage.token) {
          setAuthToken(localStorage.token);
        }
        const response = await axios.get(
          `${appUrl}/api/lelotemplate/${charter_id}/${courseid}/${id}`
        );
        if (response.data && response.data.templateMessage) {
          setContent(response.data.templateMessage);
          setHasExistingTemplate(true);
        }
      } catch (error) {
        console.error("Error fetching template:", error);
      }
    };
    fetchTemplate();
  }, [charter_id, courseid, id]);

  const handleSave = async () => {
    const isContentEmpty = !content || content.trim() === "<p><br></p>";
    const rawContent = isContentEmpty ? defaultPlaceholder : content;
  
    try {
      if (localStorage.token) {
        setAuthToken(localStorage.token);
      }
  
      const payload = {
        templateMessage: rawContent,
        charter_id: charter_id,
        permaLink: permalink,
        learningCenters: name,
        siteId: id,
        LeloRegistrationProfile: courseid,
      };
  
      let response;
      if (hasExistingTemplate) {
        response = await axios.put(
          `${appUrl}/api/lelotemplate/${charter_id}/${courseid}/${id}`,
          payload, // ✅ send directly, no `{ payload }`
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
      } else {
        response = await axios.post(
          `${appUrl}/api/lelotemplate`,
          payload, // ✅ send directly
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
      }

      toast.success("Content saved successfully!");
      setHasExistingTemplate(true);
    } catch (error) {
      console.error("Error saving content:", error);
      const errorMessage =
        error.response?.data?.message ||
        error.message ||
        "An unexpected error occurred while saving";
      toast.error(`Error saving content: ${errorMessage}`);
    }
  };
  

  return (
    <div className={styles.editConfirmationWrapper}>
      {/* <section>
        <h3 style={{ marginBottom: "5px" }}>Confirmation Editor</h3>
      </section> */}

      <section>
        <div className={styles.card}>
          <div className={styles.cardHeader}>
            <div className={styles.cardTitle}>Confirmation Page Details</div>
          </div>
          <div className={styles.cardBody}>
            <div className={styles.editorContainer}>
              <ReactQuill
                theme="snow"
                value={content}
                placeholder={`You are considered registered and there is nothing more you need to do unless you are contacted by the school for additional information.
One of our staff members will contact you with instructions and information on how to start your course. They will also be able to answer any questions you may have.
We look forward to working with you!`}
                onChange={setContent}
                modules={modules}
                formats={formats}
              />
            </div>
          </div>
          <div className={styles.cardFooter}>
            <button
              type="button"
              className={styles.saveButton}
              onClick={handleSave}
            >
              Save Changes
            </button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default EditConfirmationPage;
